import React from 'react';
import { Text } from '@chakra-ui/react';
import { Link } from 'react-router-dom';

interface AuthLinksProps {
  link1Name?: string;
  link1Url?: string;
  link2Name?: string;
  link2Url?: string;
  marginTop?: number;
}

const AuthLinks: React.FC<AuthLinksProps> = ({
  link1Name,
  link1Url,
  link2Name,
  link2Url,
  marginTop,
}) => {
  return (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        borderTop: '1px solid #EDEDED',
        paddingTop: '16px',
        marginTop: `${marginTop}px`,
        width: '100%',
      }}
    >
      <Text color="#999" fontWeight="semibold" fontSize="16px" fontFamily="Inter">
        {link1Url ? <Link to={link1Url}>{link1Name}</Link> : <span>{link1Name}</span>}
      </Text>
      <Text color="#000" fontWeight="semibold" fontSize="16px" fontFamily="Inter">
        {link2Url ? <Link to={link2Url}>{link2Name}</Link> : <span>{link2Name}</span>}
      </Text>
    </div>
  );
};

export default AuthLinks;
